module.exports = __webpack_public_path__ + "img/291.608b9486.jpg";